import { LayoutTemplate } from 'lucide-vue-next'
import type { App } from 'vue'
import { registerComponents } from './components'

export const createTemplates = () => ({
  install: (app: App) => {
    registerComponents(app)
    app.getRouter().addRoute('organization', {
      path: 'templates',
      name: 'templates',
      meta: {
        head: { titleKey: 'templates.title' },
        nav: { icon: LayoutTemplate, order: 13, section: 'nav.workspace' },
        crumbs: [{ labelKey: 'nav.workspace', to: { name: 'dashboard' } }, { labelKey: 'templates.title' }]
      },
      component: () => import('./pages/TemplatesPage.vue')
    })
  }
})
